export const roles = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  MANAGER: 'MANAGER',
  OPERATOR: 'OPERATOR',
  MERCHANT: 'MERCHANT',
  MARKETER: 'MARKETER',
};
